import React, { useState, useEffect } from "react";
import Sidebar from "../sidebar/Sidebar";
import Header from "../header/header";

interface DashboardLayoutProps {
  children: React.ReactNode;
  className?: string;
}


const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children, className = "" }) => {
  const [sidebarExpanded, setSidebarExpanded] = useState(true);

  const toggleSidebar = () => {
    setSidebarExpanded(prev => !prev);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar: fixed, independent - z-index increased in Sidebar component */}
      <Sidebar expanded={sidebarExpanded} onToggle={toggleSidebar} />
      {/* Header is now fixed at the top, receiving state and knowing Sidebar exists */}
      <Header sidebarExpanded={sidebarExpanded} hasSidebar={true} />
      <main className={`flex-1 min-w-0 pt-[100px] px-4 md:px-6 transition-all duration-500 ease-out ${sidebarExpanded ? 'md:ml-72' : 'md:ml-32'} ${className}`}>
        {children}
      </main>
    </div>
  );
};

export default DashboardLayout;